import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslatePipe } from '../pipes/translate.pipe';

/** "Sold out" veil laid over a food image. */
@Component({
  selector: 'app-sold-out-veil',
  standalone: true,
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<div style="position:absolute;inset:0;background:rgba(28,22,18,0.5);display:flex;align-items:center;justify-content:center">
      <span [style.font-size.px]="small ? 10.5 : 12" [style.padding]="small ? '3px 8px' : '5px 11px'"
        style="background:var(--fr-surface);color:var(--fr-text);font-weight:750;border-radius:8px;
               letter-spacing:0.02em;text-transform:uppercase">{{ 'Sold out' | t }}</span>
    </div>`,
})
export class SoldOutVeilComponent {
  @Input() small = false;
}
